import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const PageHeader = ({ children }) => {
  return (
    <div data-testid="page-header" className="page-header path-to-pro-page-header sui-pb-8">
      <Typography variant="h1">
        {children}
      </Typography>
    </div>
  );
};

export default PageHeader;
